<template>
    <div>
        <svg id="smiley" :class="{ selected: isHighlighted}" xmlns="http://www.w3.org/2000/svg" width="62" height="57" viewBox="0 0 62 57">
            <defs>
            </defs>
            <path id="background" d="M57.887,0H4.113A4.114,4.114,0,0,0,0,4.113V52.887A4.114,4.114,0,0,0,4.113,57H57.887A4.114,4.114,0,0,0,62,52.887V4.113A4.114,4.114,0,0,0,57.887,0ZM31,48.5a20,20,0,1,1,20-20A20,20,0,0,1,31,48.5Z"/>
            <circle id="head" style="fill: #fff;" cx="31" cy="28.5" r="16.667"/>
            <path id="head-border" d="M31,8.5a20,20,0,1,0,20,20A20,20,0,0,0,31,8.5Zm0,36.667A16.667,16.667,0,1,1,47.667,28.5,16.682,16.682,0,0,1,31,45.167Z"/>
            <ellipse id="left-eye" class="face" cx="24.5" cy="21.833" rx="3.5" ry="3.333"/>

            <path v-if="category.name == 'veryhappy'" id="mouth_very-happy" class="face" d="M39.463,31.081a1.574,1.574,0,0,0-.21-.045l-.009,0a1.644,1.644,0,0,0-.25-.026c-.027,0-.052-.008-.079-.008l-15.83,0c-.027,0-.052.007-.079.008a1.782,1.782,0,0,0-.25.026l-.009,0a1.749,1.749,0,0,0-.21.045,1.655,1.655,0,0,0-1.068,2.083A9.923,9.923,0,0,0,31,40.167v0a9.922,9.922,0,0,0,9.531-7A1.654,1.654,0,0,0,39.463,31.081Z"/>
            <path v-else-if="category.name == 'happy'" id="mouth-happy" class="face" d="M31,40.167a9.923,9.923,0,0,1-9.531-7.006,1.664,1.664,0,1,1,3.177-.989,6.661,6.661,0,0,0,12.708,0,1.677,1.677,0,0,1,2.109-1.094,1.655,1.655,0,0,1,1.068,2.083A9.923,9.923,0,0,1,31,40.167Z"/>
            <path v-else-if="category.name == 'medium'" id="mouth-medium" class="face" d="M39.333,35.167H22.667a1.667,1.667,0,0,1,0-3.334H39.333a1.667,1.667,0,0,1,0,3.334Z"/>  
            <path v-else-if="category.name == 'unhappy'" id="mouth-unhappy" class="face" d="M39.463,39.255a1.676,1.676,0,0,1-2.109-1.094,6.661,6.661,0,0,0-12.708,0,1.664,1.664,0,1,1-3.177-.99,9.987,9.987,0,0,1,19.062,0A1.655,1.655,0,0,1,39.463,39.255Z"/>
            <path v-else-if="category.name == 'veryunhappy'" id="mouth_very-unhappy" class="face" d="M22.537,39.255a1.754,1.754,0,0,0,.21.046h.009a1.526,1.526,0,0,0,.25.026c.027,0,.052.008.079.008l15.83,0c.027,0,.052-.007.079-.008a1.644,1.644,0,0,0,.25-.026l.009,0a1.574,1.574,0,0,0,.21-.045,1.654,1.654,0,0,0,1.068-2.083,9.922,9.922,0,0,0-9.531-7v0a9.922,9.922,0,0,0-9.531,7A1.654,1.654,0,0,0,22.537,39.255Z"/>

            <circle id="right-eye" class="face" cx="37.667" cy="21.833" r="3.333"/>
        </svg>
    </div>    
</template>

<script>
   export default {
     props: ['currentlyHighlightedCategoryName', 'category'],
     data: function () {
       return {}
     },
     computed: {
       isHighlighted: function () {
         return this.currentlyHighlightedCategoryName === this.category.name
       }
     }
   }
</script>

<style lang="less" scoped>
    @import '../_theme';
    
    #background{fill: #fff;}
    .face {fill: #777;}
    #head-border{fill: #777;}

    #smiley.selected #background{fill: @main-headline-color}
    #smiley.selected .face {fill: @main-headline-color}
    #smiley.selected #head-border{fill: #fff;}

</style>


// WEBPACK FOOTER //
// src/components/AppSmiley.vue